
export enum AvailableStatusCd {
	AVAILABLE = 'Available',
	SICK = 'Sick',
	TRAINING = 'Training',
	UNAVAILABLE = 'Unavailable',
	VACATION = 'Vacation'}
